import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { BannerImage, IBannerImage } from 'app/constants/schemas/BannerImage';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';

export interface IBannerTranslation extends IEntity {
  attributes: {
    id: EntityStringId;
    text: string;
    language: Language;
    target: string;
  };
  associations: {
    bannerImages: IBannerImage[];
  };
}

export type BannerTranslation = Entity<IBannerTranslation>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BannerTranslation: IEntityType<IBannerTranslation> = vmClient.defineClass({
  typeName: 'BannerTranslation',
  version: 2,
  lockable: true,
  persisted: true,
  attributes: {
    text: {
      type: 'string',
      notNull: true,
    },
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    target: {
      type: 'string',
      notNull: true,
    },
  },
  associations: {
    bannerImages: {
      type: BannerImage,
      collection: true,
      notNull: true,
    },
  },
});
